<div
  class="flex w-full min-w-0 items-end justify-start gap-1 text-sm"
  [attr.data-id]="message().id"
  [attr.data-index]="index()"
  [ngClass]="{ 'flex-row-reverse': isMyMessage() }"
>
  <div
    class="flex max-w-[60%] flex-col gap-2 rounded-xl p-2 pb-0.5 shadow-xl"
    [ngClass]="isMyMessage() ? 'bg-blue-primary text-white' : 'bg-white text-black'"
  >
    <div class="text-xs underline">
      {{ message().senderName }}
    </div>

    @if (!!message().media) {
      <div class="min-w-0 break-words">
        <pre class="whitespace-break-spaces break-words">{{ message().content }}</pre>
      </div>
    }

    <div class="min-w-0 break-words">
      @for (file of getFiles(); track file) {
        <div
          (click)="downloadFile(file)"
          class="flex cursor-pointer items-center gap-2"
          [ngClass]="isMyMessage() ? 'hover:text-gray-3' : 'hover:text-blue-primary'"
        >
          <div class="text-xl">
            <mat-icon>file_open</mat-icon>
          </div>
          <div class="text-md pb-1">{{ file }}</div>
        </div>
      }
    </div>
  </div>

  <span class="flex flex-col items-end gap-1 text-xs">
    @if (isUpdated()) {
      {{ message().updatedAt | date: "d MMM HH:mm" : "" : "uk" }} (редаговано)
    } @else {
      {{ message().createdAt | date: "d MMM HH:mm" : "" : "uk" }}
    }

    @if (isMyMessage()) {
      @switch (getState()) {
        @case (MessageState.Sent) {
          <span><mat-icon [fontIcon]="'done'"></mat-icon></span>
        }
        @case (MessageState.Read) {
          <span [title]="getUserReadReceipt().readTime | date: 'd MMM HH:mm'">
            <mat-icon [fontIcon]="'done_all'"></mat-icon>
          </span>
        }
      }
    }
  </span>
</div>
